import { TemplateRef, Directive, Input, inject } from '@angular/core';

@Directive({
  selector: '[selectPrefix]',
  standalone: false,
})
export class SelectPrefix {
  private tr = inject<TemplateRef<any>>(TemplateRef);

  @Input('selectPrefixHidden')
  hidden?: boolean;

  get template(): TemplateRef<any> | undefined {
    return !this.hidden ? this.tr : undefined;
  }
}
